// extracted by mini-css-extract-plugin
module.exports = {"settingsBox":"Settings_settingsBox__1KGUg","iconWrapper":"Settings_iconWrapper__2kg-A"};